module.exports = __webpack_public_path__ + "img/Screen Shot 2020-07-01 at 10.09.09 AM.03ab677c.png";